module.exports = __webpack_public_path__ + "static/media/1.972ad52a.jpg";